/* Southern Atelier – order product suggestions by best-sellers and fill "similar" / "complete your look" */
(() => {
  if (window.__saSuggest) return;
  window.__saSuggest = true;
  const KEY = 'sa:bestsellers';
  let pending = null;

  function bestsellers(url) {
    if (pending) return pending;
    try {
      const c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000) return (pending = Promise.resolve(c.list));
    } catch (e) {}
    pending = fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sa-bestsellers]');
        const list = el ? JSON.parse(el.textContent) : [];
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), list })); } catch (e) {}
        return list;
      })
      .catch(() => []);
    return pending;
  }

  async function fill(section) {
    const tpls = [...section.querySelectorAll('[data-sa-candidates] template')];
    if (!tpls.length) { section.remove(); return; }
    const order = await bestsellers(section.dataset.indexUrl);
    const rank = new Map(order.map((h, i) => [h, i]));
    const score = (t) => (rank.has(t.dataset.handle) ? rank.get(t.dataset.handle) : 1e6 + tpls.indexOf(t));
    tpls.sort((a, b) => score(a) - score(b));

    const limit = Number(section.dataset.limit) || 12;
    const perKind = Number(section.dataset.perKind) || 1;
    let chosen = [];
    if (section.dataset.mode === 'complete') {
      const kinds = (section.dataset.kinds || '').split(',').filter(Boolean);
      // one (or more) per complementary kind, in the order: e.g. shoes, top, socks, accessory
      for (let round = 0; round < perKind; round++) {
        for (const k of kinds) {
          const next = tpls.filter((t) => t.dataset.kind === k && !chosen.includes(t))[0];
          if (next) chosen.push(next);
        }
      }
      chosen = chosen.slice(0, limit);
    } else {
      chosen = tpls.slice(0, limit);
    }
    if (!chosen.length) { section.remove(); return; }
    const track = section.querySelector('[data-sa-track]');
    chosen.forEach((t) => track.appendChild(t.content.cloneNode(true)));
    section.querySelector('[data-sa-candidates]')?.remove();
    section.hidden = false;
    track.dispatchEvent(new Event('scroll'));
  }

  const boot = () => document.querySelectorAll('[data-sa-suggest]').forEach((s) => { if (!s.__sa) { s.__sa = true; fill(s); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
